import _lineLength from "../quill/lineLength.js";
const lineLength = _lineLength;
export default (function autoFormatCheck(event, maxLines, maxChars) {
  try {
    let textLines = lineLength.getPlainLines(event.text);
    //console.log(textLines, maxLines, maxChars);     
    if (textLines.length > maxLines) {
      //console.log("TOO MANY LINES. "+ textLines.length);
      return true;
    }
    if (textLines.some(st => st.length > maxChars)) {
      //console.log("TOO MANY CHARS. "+ textLines.length);
      return true;
    }
    return false;
  } catch (err) {
    console.log(err, err.message);
    return false;
  }
});